<!-- 专著详情页 -->
<template>
  <div class="detail-box safe-distance-top-header safe-distance-bottom-tool">
    <Header
      :pageTitle="
        DetailsList.monographName
          ? $global.matchReg(DetailsList.monographName)
          : ''
      "
      :shareInfo="shareInfo"
    />
    <Shelves v-if="isShelves" />
    <div class="content-box" v-else>
      <!-- 标题 -->
      <div class="title-box">
        <img
          class="left"
          :src="
            DetailsList.cover
              ? $global.imgUrl + DetailsList.cover
              : require('@/assets/img/mobile-img/zz_default.png')
          "
        />
        <div class="right">
          <h1 class="title" v-html="DetailsList.monographName"></h1>
          <div class="author">
            <span
              class="author-item"
              v-for="item in DetailsList.articleAuthors"
              :key="item.id"
              @click="toBaijia(item.authorId)"
              >{{ item.authorName }}</span
            >
          </div>
        </div>
      </div>
      <!-- 内容简介 -->
      <div v-if="DetailsList.artSummary" class="public-box artSummary-box">
        <div class="public-title">内容简介</div>
        <div
          class="public-text artSummary"
          v-html="DetailsList.artSummary"
        ></div>
      </div>
      <!-- 目录 -->
      <div class="public-box catalogue-box">
        <div class="public-title">目录</div>
        <div class="public-text catalogue" v-html="DetailsList.catalogue"></div>
      </div>
      <!-- 更多信息 -->
      <div class="public-box">
        <div class="public-title">更多信息</div>
        <div class="public-text" v-for="item in infoList" :key="item.key">
          <div v-if="DetailsList[item.key] && DetailsList[item.key][0] !== ''">
            <span class="public-label">{{ item.label }}</span>
            <span
              v-if="
                item.key === 'translatorJson' || item.key === 'compilerJson'
              "
              >{{ `${DetailsList[item.key]}` }}</span
            >
            <span v-else-if="item.key === 'emboitementStatus'">{{
              DetailsList[item.key] === 1 ? "是" : "否"
            }}</span>
            <span v-else>{{ DetailsList[item.key] }}</span>
          </div>
        </div>
      </div>
      <!-- 在售图书 -->
      <div class="public-box" v-if="bookList.length > 0">
        <div class="public-title">在售图书</div>
        <div
          class="book-item"
          v-for="item in bookList"
          :key="item.goods.id"
          @click="toBookDetail(item.goods.id)"
        >
          <img
            class="left"
            :src="
              item.goods.albumPics
                ? $global.imgUrl + item.goods.albumPics.split(',')[0]
                : require('@/assets/img/mobile-img/zz_default.png')
            "
          />
          <div class="right">
            <h1 class="title" v-html="item.goods.goodsName"></h1>
            <div class="price">
              <span style="font-size: 16px; font-weight: 700">{{
                item.saleType === 1 ? "¥" + item.price : "免费"
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomTool
      :title="DetailsList.monographName"
      :artSummary="DetailsList.artSummary"
      :shareInfo="shareInfo"
    >
      <template #right>
        <OnlineReading />
      </template>
    </BottomTool>
  </div>
</template>

<script>
import Shelves from "./components/shelves.vue";
import Header from "./components/detailHeader.vue";
import BottomTool from "./components/bottomTool.vue";
import OnlineReading from "./components/OnlineReading.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Header,
    Shelves,
    BottomTool,
    OnlineReading,
  },
  data() {
    //这里存放数据
    return {
      isShelves: false,
      infoList: [
        {
          key: "isbn",
          label: "ISBN",
        },
        {
          key: "press",
          label: "出版社",
        },
        {
          key: "showPublishTime",
          label: "出版时间",
        },
        {
          key: "classifyNumber",
          label: "分类号",
        },
        {
          key: "seriesTitle",
          label: "丛书名",
        },
        {
          key: "edition",
          label: "版次",
        },
        {
          key: "monographLenght",
          label: "字数",
        },
        {
          key: "pageNumber",
          label: "页数",
        },
        {
          key: "packageNumber",
          label: "包册数",
        },
        {
          key: "authorRegion",
          label: "作者地区",
        },
        {
          key: "translatorJson",
          label: "译者",
        },
        {
          key: "compilerJson",
          label: "编者",
        },
        {
          key: "makePrice",
          label: "定价",
        },
        {
          key: "emboitementStatus",
          label: "是否套装",
        },
        {
          key: "pack",
          label: "包装",
        },
        {
          key: "bookCategory",
          label: "版别",
        },
        {
          key: "bookSize",
          label: "开本",
        },
        {
          key: "paperName",
          label: "用纸",
        },
      ],
      DetailsList: [],
      shareInfo: {},
      bookList: [],
    };
  },
  filters: {
    priceFormat(value) {
      if (Array.isArray(value)) {
        return value[0] > 0 ? `¥${value[0]}` : "免费";
      } else {
        return value > 0 ? `¥${value}` : "免费";
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getDetail();
  },
  //方法集合
  methods: {
    toBookDetail(id) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "/bookDetails",
        query: {
          item: 0,
          id: id,
          out,
        },
      });
    },
    // 作者跳详情
    toBaijia(id) {
      console.log(id);
      if (id == "" || id == null || id == undefined) return;
      let out = this.$route.query.out;
      out
        ? this.$router.push(`/appusesbaijia?item=0&id=${id}&out=${out}`)
        : this.$router.push(`/appusesbaijia?item=0&id=${id}`);
    },
    // 获取详情页
    async getDetail() {
      let res = await this.$apis.recomendServe.getDetails({
        articleId: this.$route.query.id,
        articleType: this.$route.query.type,
      });
      if (res.resultCode === "200") {
        this.DetailsList = res.data.data;
        this.bookList = res.data.goods ? res.data.goods : [];
        this.shareInfo = {
          title: this.DetailsList.monographName,
          artSummary: this.DetailsList.artSummary,
          cover: this.DetailsList.cover,
          articleId: this.$route.query.id,
          articleType: this.$route.query.type,
        };
        this.$global.toShare(
          this.DetailsList.monographName,
          this.DetailsList.artSummary,
          this.DetailsList.cover
        );
      } else if (
        res.resultCode === "10401002" ||
        res.resultCode === "10401001"
      ) {
        this.isShelves = true;
      }
    },
    // 跳转到详情
    toDetail(id) {
      let out = this.$route.query.out;
      out
        ? this.$router.push(`/concentrationDetails?id=${id}&type=2&out=${out}`)
        : this.$router.push(`/concentrationDetails?id=${id}&type=2`);
    },
  },
};
</script>
<style lang='scss' scoped>
.detail-box {
  padding-top: 56px;
  padding-bottom: 61px;
  background: #f5f5f5;
  min-height: 100vh;

  .content-box {
    padding: 0 12px;

    .title-box {
      display: flex;
      margin-bottom: 15px;

      .left {
        margin-right: 15px;
        width: 110px;
        height: 110px;
        border-radius: 5px;
        border: 1px solid #eeeeee;
        background-color: #fff;
        object-fit: contain;
      }

      .right {
        flex: 1;

        .title {
          margin-top: 11px;
          font-size: 17px;
          color: #333333;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .author {
          margin-top: 20px;
          font-size: 13px;
          color: #4a79f1;
          line-height: 19px;

          .author-item {
            margin-right: 10px;
          }
        }
      }
    }
    .catalogue-box,
    .artSummary-box  {
      // height: 280px;
      // overflow: hidden;
      .catalogue,
      .artSummary {
        p {
          height: 30px;
          line-height: 30px;
        }

        &::v-deep video,
        &::v-deep img {
          display: block;
          max-width: 100% !important;
          height: auto !important;
          text-indent: unset;
        }
      }
    }

    .book-item {
      display: flex;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      &:last-child {
        margin-bottom: 0;
        border: none;
      }

      .left {
        margin-right: 15px;
        width: 90px;
        height: 90px;
        border-radius: 4px;
        border: 1px solid #eeeeee;
        background-color: #fff;
        object-fit: contain;
      }

      .right {
        padding: 5px 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
          font-size: 15px;
          color: #333333;
          line-height: 21px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .price {
          color: #ff3d3d;
          line-height: 17px;
        }
      }
    }
  }
}

.public-box {
  margin-bottom: 12px;
  padding: 15px 12px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;

  .public-title {
    margin-bottom: 20px;
    font-size: 17px;
    font-weight: 700;
    color: #333333;
    line-height: 24px;
  }

  .public-text {
    font-size: 15px;
    font-family: PingFang;
    font-weight: 500;
    color: #333333;
    word-break: break-all;

    .public-label {
      display: inline-block;
      margin-bottom: 15px;
      width: 86px;
    }
  }
  .artSummary {
    img {
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>